// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5ed2d4a4","508":"199fe12d","776":"cbbe6da3"}[chunkId] + ".chunk.js";
};